import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  formWrapper: {
    width: 'fit-content',
    maxWidth: '760px',
    padding: '30px',
  },
  switch: {
    paddingTop: '0px',
  },
  switchVerticalOption: {
    paddingTop: '0px',
  },
  distanceField: {
    width: 90,
    marginRight: 8,
  },
  caption: {
    display: 'flex',
    alignItems: 'center',
    color: '#2196F3',
  },
  captionText: {
    maxWidth: '460px',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  icon: {
    border: '1px solid #2196F3',
    borderRadius: '50%',
    padding: '2px',
    height: '20px',
    width: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '8px',
    '& svg': {
      height: '18px',
      width: '18px',
    },
  },
}));

export default useStyles;
